var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 10.105,
    height: 13.982,
    viewBox: "0 0 10.105 13.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.88,10.584a2.5,2.5,0,0,0,1.907-.863,2.961,2.961,0,0,0,.793-2.076V2.94a2.961,2.961,0,0,0-.793-2.076,2.538,2.538,0,0,0-3.814,0,2.961,2.961,0,0,0-.793,2.076v4.7a2.962,2.962,0,0,0,.793,2.076A2.5,2.5,0,0,0,148.88,10.584Z",
    transform: "translate(-143.827 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.025,182.9a.533.533,0,0,0-.789,0,.579.579,0,0,0-.167.413v1.176a4.06,4.06,0,0,1-1.154,2.908,3.794,3.794,0,0,1-5.552,0,4.06,4.06,0,0,1-1.153-2.908v-1.176a.579.579,0,0,0-.167-.413.534.534,0,0,0-.789,0,.578.578,0,0,0-.167.413v1.176a5.241,5.241,0,0,0,1.294,3.532,4.829,4.829,0,0,0,3.2,1.722v1.213H78.7v-1.213a4.829,4.829,0,0,0,3.2-1.722,5.241,5.241,0,0,0,1.294-3.532v-1.176A.578.578,0,0,0,83.025,182.9Z",
    transform: "translate(-73.087 -176.974)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMessage);
export default __webpack_public_path__ + "static/media/audioMessage.722f450cbf5eed7d0471ea5b2fda7220.svg";
export { ForwardRef as ReactComponent };